import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js'
import { Fancybox } from "@fancyapps/ui";

export default class extends Controller {
  static classes = ['hidden', 'visible']
  static targets = ['emailVerified', 'notice', 'verificationCode', 'unverifiedEmail']
  static values = {
    url: String
  }

  connect () {
    if (this.hasVerificationCodeTarget) {
      this.verificationCodeTarget.id = 'verification-code-modal';
    }

    if (this.hasNoticeTarget) {
      this.noticeTemplate = this.noticeTarget.textContent;
    }
  }

  async createVerificationCode (email) {
    const request = new FetchRequest('post', this.urlValue, {
      body: { subject: email }
    })

    await request.perform()
  }

  verify (event) {
    event.preventDefault()

    if (this.unverifiedEmailTarget.value !== '') {
      this.createVerificationCode(this.unverifiedEmailTarget.value)
      this.showVerificationInput(event)
    }
  }

  showVerificationInput (event) {
    event.preventDefault()

    this.verificationCodeTarget.classList.remove(this.hiddenClass)
    this.verificationCodeTarget.dataset.unverifiedEmail = this.unverifiedEmailTarget.value;
    this.updateNoticeText()

    this.fancybox = Fancybox.show(
      [{
        src: this.verificationCodeTarget.id,
        type: 'inline',
      }]
    )
  }

  updateNoticeText () {
    const email = this.verificationCodeTarget.dataset.unverifiedEmail

    if (email && this.hasNoticeTarget) {
      this.noticeTarget.textContent = this.noticeTemplate.replace('%{email}', email)
    }
  }

  verificationCodeVerified () {
    if (this.fancybox) {
      this.fancybox.close();
      this.emailVerifiedTarget.classList.remove(this.hiddenClass);
      this.emailVerifiedTarget.classList.add(this.visibleClass);
    }
  }
}
